import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  target: 'body',
  showConfirmButton: false,
  timer: 3000,
  position: 'top'
});

class Notification {
  success(message: string): Promise<any> {
    return Toast.fire({
      icon: 'success',
      title: message
    });
  }

  warning(message: string, showConfirmButton = false): Promise<any> {
    return Toast.fire({
      icon: 'warning',
      title: message,
      showConfirmButton
    });
  }

  error(message: string): Promise<any> {
    return Toast.fire({
      icon: 'error',
      title: 'Ops!',
      text: message
    });
  }

  confirm(
    title: string,
    message: string,
    confirmButtonText?: string,
    cancelButtonText?: string,
    showCancelButton?: boolean
  ): Promise<any> {
    return Swal.fire({
      icon: 'warning',
      title,
      text: message,
      confirmButtonText: confirmButtonText ?? 'OK',
      cancelButtonText: cancelButtonText ?? 'Cancelar',
      showCancelButton: showCancelButton ?? true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSecondary',
        cancelButton: 'MuiButtonBase-root MuiButton-root MuiButton-contained'
      }
    });
  }

  loading(message: string): Promise<any> {
    return Swal.fire({
      title: message,
      toast: true,
      showConfirmButton: false,
      onBeforeOpen: function () {
        Swal.showLoading();
      }
    });
  }
}

export default new Notification();
